import { useCallback, useSyncExternalStore } from 'react'

/** Folgt einer Media Query. Ohne matchMedia (Tests, alte Umgebungen) gilt `fallback`. */
export function useMediaQuery(query: string, fallback = false): boolean {
  const subscribe = useCallback(
    (notify: () => void) => {
      if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => {}
      const list = window.matchMedia(query)
      list.addEventListener('change', notify)
      return () => list.removeEventListener('change', notify)
    },
    [query],
  )
  const snapshot = (): boolean =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : fallback
  return useSyncExternalStore(subscribe, snapshot, () => fallback)
}

/** Grenze Telefon/Tablet: unter 768 px werden Dialoge zu Sheets und Tabellen zu Karten. */
export const PHONE_QUERY = '(max-width: 767.98px)'
export const COARSE_QUERY = '(pointer: coarse)'

export const useIsPhone = (): boolean => useMediaQuery(PHONE_QUERY)
export const useIsCoarsePointer = (): boolean => useMediaQuery(COARSE_QUERY)
